import { render, staticRenderFns } from "./scope107.vue?vue&type=template&id=2f52ba3e&scoped=true"
import script from "./scope107.vue?vue&type=script&lang=js"
export * from "./scope107.vue?vue&type=script&lang=js"
import style0 from "./scope107.vue?vue&type=style&index=0&id=2f52ba3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52ba3e",
  null
  
)

export default component.exports